import React from 'react';
import ReferralDetails from './Components/ReferralDetails';

const ReferralDetailsPage = () => {
  return (
    <div className="w-full h-full">
      <div className="pb-1">
        <ReferralDetails />
      </div>
    </div>
  );
};

export default ReferralDetailsPage;
